import PropTypes from 'prop-types';
import { Input } from 'antd';
import styled from 'styled-components';
import { formatNumberWithCommas } from '@/utils/money';

const baseCss = `
  border-radius: 12px;
  font-family: var(--font-family-lufga);
`;

const StyledAppInput = styled(Input)`
  ${baseCss}

  &.ant-input,
  &.ant-input-affix-wrapper {
    height: 44px;
    padding: 0 12px;
    display: flex;
    align-items: center;
  }

  .ant-input {
    height: 42px;
  }
`;

const StyledAppPassword = styled(Input.Password)`
  ${baseCss}

  &.ant-input-affix-wrapper {
    height: 44px;
    padding: 0 12px;
    display: flex;
    align-items: center;
  }

  .ant-input {
    height: 42px;
  }
`;

export const AppInput = ({ isPrice, prefix, onChange, onBlur, inputMode, ...props }) => {
    if (!isPrice) {
        return <StyledAppInput prefix={prefix} onChange={onChange} onBlur={onBlur} inputMode={inputMode} {...props} />;
    }

    const pricePrefix =
        prefix ??
        (
            <span style={{ fontWeight: 700, opacity: 0.85, fontSize: 12, lineHeight: '12px' }}>
                Rs.
            </span>
        );

    return (
        <StyledAppInput
            {...props}
            inputMode={inputMode || 'numeric'}
            prefix={pricePrefix}
            onChange={(e) => {
                const raw = String(e?.target?.value ?? '');
                const digits = raw.replace(/[^\d]/g, '');
                const next = digits ? formatNumberWithCommas(digits) : '';
                if (onChange) onChange({ ...e, target: { ...e.target, value: next } });
            }}
            onBlur={(e) => {
                const raw = String(e?.target?.value ?? '');
                const formatted = formatNumberWithCommas(raw);
                if (onChange) onChange({ ...e, target: { ...e.target, value: formatted } });
                if (onBlur) onBlur(e);
            }}
        />
    );
};

export const AppPasswordInput = (props) => {
    return <StyledAppPassword {...props} />;
};

export const AppTextArea = styled(Input.TextArea)`
  ${baseCss}
`;

AppInput.propTypes = {
    size: PropTypes.oneOf(['small', 'middle', 'large']),
    isPrice: PropTypes.bool,
};

